import React from 'react';
import styled, { StylesProps, cx } from '../../../lib/styles';
import { Brand } from '../../../lib/theme';
import { Article } from '../../../models/article';
import Typography from '../Typography';

import teaserStoryStyles from './TeaserStory_styles';

export interface Teaser {
  slot?: string;
  title: string;
  showMoreText?: string;
  article: Article;
}

interface TeaserStoryProps extends Teaser {
  brand?: Brand;
  onClick?: () => any;
}

const TeaserStory = ({
  slot,
  article: { title: articleTitle, link, excerpt },
  onClick,
  title,
  showMoreText,
  styles,
}: TeaserStoryProps & StylesProps<typeof teaserStoryStyles>) => {
  return (
    <div id={slot} data-parsely-slot={slot}>
      <a
        href={link}
        title={articleTitle}
        className={cx('TeaserStory', styles.link)}
        onClick={onClick}
      >
        <Typography className={styles.teaser}>
          <div className={styles.text}>
            <Typography color={'primary'}>
              <h4>
                <strong>{title}</strong>
              </h4>
            </Typography>

            <h3 className={cx(styles.title, 'Story__title')}>{articleTitle}</h3>
            <Typography color={'dark_grey'} family={'copy'}>
              {excerpt}{' '}
              {showMoreText && (
                <span className={styles.showMore}>{showMoreText}</span>
              )}
            </Typography>
          </div>
        </Typography>
      </a>
    </div>
  );
};

export default styled(teaserStoryStyles)(TeaserStory);
